type OnboardingTaskLike = { category: string; status: string };

export interface OnboardingProgress {
  verificationCompleted: boolean;
  signatureCompleted: boolean;
  paymentCompleted: boolean;
  paymentProcessing: boolean;
}

export type OnboardingStep =
  | "verification"
  | "signature"
  | "payment"
  | "complete";

/**
 * Onboarding is driven entirely by task status: a step whose task was created
 * as completed — because its integration was switched off for the client — is
 * already done and never shown.
 */
export const deriveOnboardingProgress = (
  tasks: OnboardingTaskLike[] | null | undefined
): OnboardingProgress => {
  const list = tasks ?? [];
  const isCompleted = (category: string) =>
    list.some((t) => t.category === category && t.status === "completed");

  return {
    verificationCompleted: isCompleted("verification"),
    signatureCompleted: isCompleted("signature"),
    paymentCompleted: isCompleted("payments"),
    paymentProcessing: list.some(
      (t) => t.category === "payments" && t.status === "processing"
    ),
  };
};

export const resolveOnboardingStep = (
  progress: OnboardingProgress
): OnboardingStep => {
  if (!progress.verificationCompleted) return "verification";
  if (!progress.signatureCompleted) return "signature";
  if (!progress.paymentCompleted) return "payment";
  return "complete";
};
